export const UPDATE_CURRENT_USER = "NEW_UPDATE_CURRENT_USER";
